import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet ,useNavigate,useMatch } from "react-router-dom";
import { loginSelector } from "../store/slices/loginSlice";
import {useLocation}from "react-router";

const SpecialApproveRoutes = (props: any) => {
    const loginReducer = useSelector(loginSelector);
    const auth = loginReducer.result;
    const prevLocation = useLocation();
    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch("/approvepricelistid2/:id");

    let id = match?.params.id;
    // return auth  ?<Navigate to="/approve" />:<Navigate to="/login" />;
    let linkpage = "/approvepricelist/"+id
    // console.log("id:"+id)
    // console.log("page:"+linkpage)
    return auth  ? <Navigate to={linkpage} />:<Navigate to="/login"/>;
 
};

export default SpecialApproveRoutes;